<!--
 * @Descripttion: 边框
 * @Author: zenghua.wang
 * @Date: 2021-11-03 15:38:26
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-28 17:40:18
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    v-show="!option.hide"
  >
    <div :style="styleBorder"></div>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import { setPx, isEmpty } from '@/dragComponents/utils'

export default {
  name: 'drag-border',
  mixins: [bem],
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    styleSize() {
      return {
        width: setPx(this.width),
        height: setPx(this.height)
      }
    },
    styleBorder() {
      let { sliceTop, sliceBottom, sliceLeft, sliceRight } = this.option
      return Object.assign(
        {
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          boxSizing: 'border-box',
          backgroundColor: this.option.backgroundColor,
          backgroundClip: 'padding-box',
          opacity: this.option.opacity,
          filter: `alpha(${this.option.opacity * 100})`,
          // eslint-disable-next-line no-dupe-keys
          filter: `progid:DXImageTransform.Microsoft.Alpha(opacity=${
            this.option.opacity * 100
          })`
        },
        (() => {
          if (
            this.option.borderType === 'image' &&
            !isEmpty(this.option.borderImage)
          ) {
            return {
              borderWidth: `${setPx(sliceTop)} ${setPx(sliceRight)} ${setPx(
                sliceBottom
              )} ${setPx(sliceLeft)}`,
              borderStyle: this.option.borderStyle,
              borderImageSource: `url(${this.option.borderImage})`,
              borderImageSlice: `${sliceTop} ${sliceRight} ${sliceBottom} ${sliceLeft} fill`,
              transform: `rotate(${this.option.angle}deg)`
            }
          }
          return {}
        })(),
        (() => {
          if (this.option.borderType === 'normal') {
            return {
              borderWidth: setPx(this.option.borderWidth),
              borderRadius: setPx(this.option.borderRadius),
              borderStyle: this.option.borderStyle,
              borderColor: this.option.borderColor
            }
          }
          return {}
        })()
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.drag-border {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
